/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type WhoAmIQueryVariables = {||};
export type WhoAmIQueryResponse = {|
  +whoAmI: ?{|
    +groups: $ReadOnlyArray<{|
      +name: string
    |}>
  |}
|};
export type WhoAmIQuery = {|
  variables: WhoAmIQueryVariables,
  response: WhoAmIQueryResponse,
|};
*/


/*
query WhoAmIQuery {
  whoAmI {
    groups {
      name
    }
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "concreteType": "GroupType",
  "kind": "LinkedField",
  "name": "groups",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "WhoAmIQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserType",
        "kind": "LinkedField",
        "name": "whoAmI",
        "plural": false,
        "selections": [
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "WhoAmIQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserType",
        "kind": "LinkedField",
        "name": "whoAmI",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "045d732159d73b6498b3e7b41bb507e1",
    "id": null,
    "metadata": {},
    "name": "WhoAmIQuery",
    "operationKind": "query",
    "text": "query WhoAmIQuery {\n  whoAmI {\n    groups {\n      name\n    }\n    id\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '509c2363e792dfb65af040a774f2b3c5';

module.exports = node;
